import React, { useState } from "react";
import "./index.scss";
import { NavItems } from "@components/navItems";
import ToggleSwitch from "@components/Home/ToggleSwitchLang/ToggleSwitchLang";
import HasPermission from "HasPermission/HasPermission";

export const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div
      className={`flex h-screen sidebar p-3 ${isCollapsed ? "collapsed" : ""}`}>
      {" "}
      <div className="sidebar-card-title">
        <h1 className="sidebar-title">INVOICIA</h1>
        <ToggleSwitch />
      </div>
      <div className="sidebar-card-menu">
        <NavItems
          isCollapsed={isCollapsed}
          toggleSidebar={() => setIsCollapsed(!isCollapsed)}
        />
      </div>
    </div>
  );
};
